import axios from "axios";

export default {
    addUpdate: (obj) => axios.post("/api/mobile/add_update", obj),
    clearLogs: (id) => axios.get(`/api/mobile/clear_logs/${id}`),
    getMobileData: (ctrl) => axios.get("/api/mobile/get_mobile_data", ctrl && { signal: ctrl.signal }),
};
